import { Layout } from "antd";
import { ProductNameEnum } from "../../types/ProductNameEnum";

const appName = process.env.REACT_APP_NAME as ProductNameEnum;

const Footer = () => {
  const { Footer } = Layout;
  let style = {};

  if (appName === ProductNameEnum.KaroPay) {
    style = {
      ...style,
      textAlign: "center"
    };
    return <Footer style={style}>Copyright © 2023 </Footer>;
  }

  return <Footer style={style}>Copyright © 2023 {appName}</Footer>;
};

export default Footer;
